var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 2",
    d: "M4.99951 0.5C3.67404 0.501365 2.40331 0.959649 1.46606 1.77432C0.528811 2.58899 0.00157077 3.69354 0 4.84566C0 7.81986 4.47423 12.1853 4.66515 12.3702C4.70736 12.411 4.75899 12.4437 4.81668 12.466C4.87437 12.4884 4.93684 12.5 5 12.5C5.06317 12.5 5.12563 12.4884 5.18332 12.466C5.24101 12.4437 5.29264 12.411 5.33485 12.3702C5.52577 12.1862 10 7.81986 10 4.84566C9.99843 3.69339 9.47106 2.58872 8.53359 1.77402C7.59613 0.959321 6.32515 0.501138 4.99951 0.5ZM4.99951 7.03482C4.5021 7.03482 4.01586 6.90665 3.60224 6.6665C3.18862 6.42634 2.86618 6.085 2.6757 5.6856C2.48521 5.28621 2.43522 4.84669 2.53205 4.4226C2.62887 3.99852 2.86816 3.6089 3.21967 3.303C3.57119 2.9971 4.01915 2.78864 4.50693 2.70398C4.99471 2.61932 5.50041 2.66225 5.96012 2.82736C6.41983 2.99246 6.81292 3.27232 7.08969 3.63156C7.36646 3.9908 7.5145 4.4133 7.51508 4.84566C7.51509 5.42581 7.25015 5.98225 6.77847 6.39272C6.30679 6.80319 5.66695 7.03414 4.99951 7.03482Z",
    fill: "#149DB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinBlue);
export default __webpack_public_path__ + "static/media/pin_blue.27905dab3d47d26f3436038ef5b8491f.svg";
export { ForwardRef as ReactComponent };